import axios from "axios";
import { safeStorage } from "@/lib/safeStorage";

export const API_BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${API_BASE}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = safeStorage.getItem("bv_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const errMsg = (e) => e?.response?.data?.detail || e?.message || "Ismeretlen hiba";

export const cleanPayload = (o) => Object.fromEntries(Object.entries(o).filter(([k]) => !k.startsWith("_")));

export const trackClick = async (targetType, targetId, targetName) => {
  try {
    await api.post("/track-click", { target_type: targetType, target_id: targetId, target_name: targetName });
  } catch {
    /* silently ignore */
  }
};

export const subscribeNewsletter = (email, source = "footer") =>
  api.post("/newsletter", { email, source, consent: true });

export const fetchCasinos = (params = {}) => api.get("/casinos", { params }).then((r) => r.data);
export const fetchBookmakers = (params = {}) => api.get("/bookmakers", { params }).then((r) => r.data);
export const fetchPoker = () => api.get("/poker").then((r) => r.data);
export const fetchBlog = (params = {}) => api.get("/blog", { params }).then((r) => r.data);
export const fetchPromoCodes = (params = {}) => api.get("/promo-codes", { params }).then((r) => r.data);

export const fmtHUF = (n) => {
  if (!n) return "0 Ft";
  return new Intl.NumberFormat("hu-HU").format(n) + " Ft";
};

export const slugify = (s) =>
  s
    .toLowerCase()
    .replaceAll("á", "a")
    .replaceAll("é", "e")
    .replaceAll("í", "i")
    .replaceAll("ó", "o")
    .replaceAll("ö", "o")
    .replaceAll("ő", "o")
    .replaceAll("ú", "u")
    .replaceAll("ü", "u")
    .replaceAll("ű", "u")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
